





































import Vue from 'vue';
import Component from 'vue-class-component';
import router from '@/router';
import { ObjectFactory } from '../config/objectFactory';
import { MedTransGoConstants } from '../util/constants';
import DataTable from '../components/DataTable.vue';
import { CommonUtils } from '../util/commonUtils';
import { DateUtils } from '../util/dateUtils';
import { MathUtils } from '../util/mathUtils';
import { Invoice, MonthlyInvoice } from '../types/entity';
import { Condition } from '../types/queryRequest';
import Menu from '../components/Menu.vue';
import { ResourceUtils } from '@/util/resourceUtils';
import { ApiRequest, QueryRecordsRequest } from '@/types/request';
import ViewReceiptModal from './modal/ViewReceiptModal.vue';
// tslint:disable-next-line: no-var-requires
const InvoicesTable = require('../datatable/InvoicesTable.json');
// tslint:disable-next-line: no-var-requires
const monthlyInvoice = require('../datatable/MonthlyInvoice.json');
@Component({
    watch: {
        $route(to, from) {
            const request = this as Invoices;
            request.getInvoiceList();
        },
    },
    methods: {
        goBack() {
            router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        },
    },
    data() {
        return {
            header: 'Invoices',
            options: [
                {
                    url: 'invoices?invoiceType=Patient',
                    activeConditions: {
                        invoiceType: 'Patient',
                    },
                    label: 'Patient Invoice(s)',
                },
                {
                    url: 'invoices?invoiceType=Monthly',
                    activeConditions: {
                        invoiceType: 'Monthly',
                    },
                    label: 'Monthly Invoice',
                },
            ],
        };
    },
    components: {
        DataTable,
        Menu,
        ViewReceiptModal,
    },
})
export default class Invoices extends Vue {
    private monthlyInvoiceDataSource = monthlyInvoice;
    private invoicesDataSource = InvoicesTable;
    private monthlyInvoicesDataSource = [];
    private type: any = 'I';
    private monthlyInvoiceStart = 0;
    private organizationId = '';
    private fileName = '';
    private showMonthlyInvoice = false;

    public mounted() {
        this.getInvoiceList('', 0);
        const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        if (memberProfile.memberType === 'ORG_MANAGER' || memberProfile.memberType === 'ORG_CUSTOMER') {
            this.$router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        }
        if (memberProfile && memberProfile.organization) {
            this.organizationId = memberProfile.organization.id;
        }
        this.getMonthlyInvoices('', 0);
    }

    private async getInvoiceList(searchString?: string, start?: number, conditions?: Condition[]) {
        this.type = this.$route.query.type ? this.$route.query.type : 'I';
        const response = await ObjectFactory.getInvoiceService().getInvoiceList(this.$store.state.serverUrl, {
                conditions: [{
                    fieldName: 'status',
                    op: 'in',
                    value: ['Completed', 'Approved'],
                }],
                start,
                limit: MedTransGoConstants.PAGINATION_LIMIT,
            }, this.type);
        if (response.success && response.data) {
            response.data.forEach((element: any) => {
                element.totalAmount = 0;
                element.particulars.forEach((iElement: any) => {
                    element.totalAmount += iElement.amount;
                });
                element.totalAmount = MathUtils.formatCurrency(element.totalAmount);
                element.createdOn = DateUtils.formatDate(element.createdOn);
                element.status = element.status === 'Approved' ? 'Unpaid' :
                    (element.status === 'Completed' ? 'Paid' : element.status);
            });
            this.invoicesDataSource.data = response.data;
            if (response.totalCount) {
                this.invoicesDataSource.totalCount = response.totalCount;
            }
        } else {
            CommonUtils.showError(response);
        }
    }

    private viewInvoice(invoice: Invoice) {
        this.$router.push({ path: `/invoices/${invoice.id}`});
    }
    private viewOriginalInvoice(invoice: Invoice) {
        this.$router.push({ path: `/invoices/${invoice.id}?orignal=true`});
    }

    private async viewReceipt(invoice: Invoice) {
        if (invoice.paymentResponse) {
            window.open(invoice.paymentResponse.receiptUrl, 'Payment Receipt', 'width=600,height=800');
        }
   }

    private viewOrderForm(invoice: Invoice) {
        if (invoice.requestId) {
            this.$router.push({ path: MedTransGoConstants.URL_VIEW_ORDER.replace(':id',
             invoice.requestId), append: true});
        }
    }

    private getFilterConditions(): Condition[] {
        const filterConditions: Condition[] = [];
        let datasource;
        datasource = this.invoicesDataSource;
        datasource.filters.forEach((filter: any) => {
            if (filter.name === 'StatusFilter') {
                const selectedStatus: string[] = [];
                filter.values.forEach((filterValue: any) => {
                    if (filterValue.value) {
                        selectedStatus.push(filterValue.dbValue);
                    }
                });
                if (selectedStatus.length > 0) {
                    filterConditions.push({
                        fieldName: 'status',
                        op: 'in',
                        value: selectedStatus,
                    });
                }
            }
        });
        return filterConditions;
    }
     private async downloadInvoice(invoice: any) {
        const pdfBuffer = await ObjectFactory.getInvoiceService().
        getInvoiceReceipt(this.$store.state.serverUrl, invoice.id) as any;
        const file = new Blob([pdfBuffer], {type: 'application/pdf'});
        ResourceUtils.downloadFileIntoDevice(file , `${invoice.invoiceId}.pdf`);
    }

    private async filterRequests(filter: any) {
        this.getInvoiceList('', 0);
    }
    private async getMonthlyInvoices(searchString?: string, start?: number) {
        const organizationId = this.organizationId;
        if (typeof start !== 'undefined') {
            this.monthlyInvoiceStart = start;
        } else if (this.monthlyInvoiceStart > 0) {
            start = this.monthlyInvoiceStart;
        }
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            limit: MedTransGoConstants.PAGINATION_LIMIT,
            start,
            conditions: [{
                fieldName: 'displayToCustomer',
                op: 'eq',
                value: true,
            }],
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/${organizationId}/getmonthlyInvoiceList`,
            data: queryRecordsRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<MonthlyInvoice[]>(apiRequest);
        if (response.success && response.data) {
            response.data.forEach((invoice: MonthlyInvoice) => {
                invoice.createdOn = DateUtils.formatDate(invoice.createdOn, DateUtils.FORMAT_DATETIME_AM_PM) as any;
                invoice.dueDate = DateUtils.formatDate(invoice.dueDate, DateUtils.FORMATE_DATE);
                invoice.amount = `$${(parseFloat(invoice.amount) / 100).toFixed(2)}`;
            });
            if (response.totalCount) {
                this.monthlyInvoiceDataSource.totalCount = response.totalCount;
            }
            this.monthlyInvoiceDataSource.data =  response.data;
        }
    }

    private async viewMonthlyInvoice(invoiceDetails: MonthlyInvoice) {
        this.fileName = invoiceDetails.pdfResourceUrl;
        this.showMonthlyInvoice = true;
    }

    private viewPaymentReciept(invoiceDetails: MonthlyInvoice) {
        window.open(invoiceDetails.paymentInfo.receiptUrl, '_blank');
    }
}
